import {resolveApiUrl} from '../lib/api';

export default {
    actions: {
        loadCams() {
            return this.dispatch('sendRequest', { path: '/cam/cam', method: 'get', formErrors: {} })
                .then(cams => cams.map(cam => ({
                    ...cam,
                    icon: resolveApiUrl(cam.icon),
                    stream_path: resolveApiUrl(cam.stream_path),
                })));
        },
        loadVideos(state, {id, params}) {
            return this.dispatch('sendRequest', { path: '/cam/cam/'+id+'/hour', params, method: 'get', formErrors: {} })
                .then(hours => hours.map(hour => ({
                    ...hour,
                    videos: hour.videos.map(video => ({
                        ...video,
                        icon: resolveApiUrl(video.icon),
                        video: resolveApiUrl(video.video),
                    })),
                })));
        }
    }
}
